import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyHotelBookingPartnerSearch = loadable(
  () => import(/* webpackChunkName: "content/hotel/partnersearch" */ './HotelBookingPartnerSearch'),
  'HotelBookingPartnerSearch',
);
